import config from '../../config.json';

export function getConfig() {
  return config;
}
